import drawerMenu from './modules/mobile-menu-drawer';
import heroText from './modules/hero-typewriter-text';
import faqAccordionBlock from './modules/faq-accordion-block';
import utilityMenu from './modules/utility-menu';
import loginButtons from './modules/login-buttons';

document.addEventListener('DOMContentLoaded', function() {
  drawerMenu();
  heroText();
  faqAccordionBlock();
  utilityMenu();
  loginButtons();
  misc();
});

function misc() {
  jQuery(document).on('facetwp-refresh', function() {
    if ( FWP.soft_refresh == true ) {
        FWP.enable_scroll = true;
    } else {
        FWP.enable_scroll = false;
    }
  });
  jQuery(document).on('facetwp-loaded', function() {
    if ( FWP.enable_scroll == true ) {
        jQuery('html, body').animate({ scrollTop: jQuery(".facetwp-template").offset().top }, 300);

        var mt = document.querySelectorAll(".modal-toggle");
        getAllExternalModal();
    }
  });

  //https://codepen.io/pwkip/pen/oNvxNYZ
  jQuery('.same-height').each(function(){

    var $this = jQuery(this);

    var equalHeightSelectors = $this.data('eh');

    jQuery.each(equalHeightSelectors, function( index, value ) {

      var min_height = 0;
      var $children = $this.find(value);
      $children.each(function(){
        var $el = jQuery(this);
        if($el.height() > min_height){
          min_height = $el.height();
        }
      });

      $children.height(min_height);

    });

  });
  document.addEventListener('facetwp-loaded', function() {
    getAllExternalModal();
  });


  var cb = document.querySelectorAll(".close");
  var i = 0;
  for (i = 0; i < cb.length; i++) {


    cb[i].addEventListener('keydown', function(e) {
      if (e.keyCode == 27) {
        var dia = this.parentNode.parentNode; /* You need to update this part if you change level of close button */
        dia.style.opacity = 0;

        dia.style.zIndex = -1;
        dia.style.display = "none";
   

        if(jQuery(this).hasClass('close-news')){
          // remove focus on non login btn
        }else{
          jQuery('.login-modal-toggle').get(0).focus();
        }

      }
    });

     cb[i].addEventListener("click", function() {


        var dia = this.parentNode.parentNode; /* You need to update this part if you change level of close button */
        dia.style.transition = 'opacity 0.2s ease';
        dia.style.opacity = 0;
        dia.style.display = "none";

        dia.style.zIndex = -1;
        if(jQuery(this).hasClass('close-news')){
          // remove focus on non login btn
        }else{
          jQuery('.login-modal-toggle').get(0).focus();
        }

     });
  }

  var cb = document.querySelectorAll(".cancel-link-btn");
  var i = 0;
  for (i = 0; i < cb.length; i++) {

    cb[i].addEventListener('keydown', function(e) {
      if (e.keyCode == 27) {
        var dia = this.parentNode.parentNode; /* You need to update this part if you change level of close button */
        dia.style.transition = 'opacity 0.2s ease';
        dia.style.opacity = 0;
        dia.style.display = "none";
  

        dia.style.zIndex = -1;
        if(jQuery(this).hasClass('close-news')){
          // remove focus on non login btn
        }else{
          jQuery('.login-modal-toggle').get(0).focus();
        }
      }
    });
     cb[i].addEventListener("click", function() {
        var dia = this.parentNode.parentNode.parentNode.parentNode; /* You need to update this part if you change level of close button */
        dia.style.opacity = 0;
        dia.style.display = "none";

        dia.style.zIndex = -1;
        if(jQuery(this).hasClass('close-news')){
          // remove focus on non login btn
        }else{
          jQuery('.login-modal-toggle').get(0).focus();
        }
     });
  }


  var ee = document.querySelectorAll(".enroll");
  var i = 0;
  for (i = 0; i < ee.length; i++) {

    ee[i].addEventListener("click", function() {
      var targetId = this.getAttribute("data-open");
      var target = document.getElementById(targetId);
        var dia = this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode; /* You need to update this part if you change level of close button */
        dia.style.opacity = 0;
        dia.style.zIndex = -1;

        target.style.display = "flex";
        target.style.opacity = 1;
        target.style.zIndex = 9999;
     });
  }


  function getAllExternalModal(){
    var mt = document.querySelectorAll(".modal-toggle");
    var i = 0;
    for (i = 0; i < mt.length; i++) {
      mt[i].addEventListener("click", function(event) {
        event.preventDefault();
          var targetId = this.getAttribute("data-target");
          var dataLink = this.getAttribute("data-link");

          var closeItem = document.getElementById("close-news");
          closeItem.focus();


          var target = document.getElementById(targetId);
          var dataLinkContent = document.getElementById("data-link");
          var dataLinkBtn = document.getElementById("data-link-btn");


          while( dataLinkContent.firstChild ) {
            dataLinkContent.removeChild( dataLinkContent.firstChild );
          }
          dataLinkContent.appendChild( document.createTextNode(dataLink) );

          if(dataLinkContent){
            dataLinkContent.setAttribute('href', dataLink)
          }

          if(dataLinkBtn){
            dataLinkBtn.setAttribute('href', dataLink)
          }
          
          target.style.opacity = 1;
          target.style.display = "flex";
          target.style.zIndex = 9999;
      });
    }
  }

  function isExternal(url) {
    if (/tellyourfriends\.com/.test(url)) {
      return false;
    }

    if (/elfi\.com/.test(url)) {
      return false;
    }

    if (/southeastbank\.mortgagewebcenter\.com/.test(url)) {
      return false;
    }

    if (/southeast\.insuranceaisle\.com/.test(url)) {
      return false;
    }

    if (/\.southeastbank\.com/.test(url)) {
      return false;
    }

    return true;
  }

  function makeExternal(link) {
    var url     = link.getAttribute('href');
    if (url !== null && !url.includes('javascript:void')) {
      var host = window.location.hostname.toLowerCase();
      var regex = new RegExp('^(?:(?:f|ht)tp(?:s)?\:)?//(?:[^\@]+\@)?([^:/]+)', 'im');
      var match = url.match(regex);
      var domain = ((match ? match[1].toString() : ((url.indexOf(':') < 0) ? host : ''))).toLowerCase();
      var className = link.className;



      // Same domain or a subdomain of southeastbank.com and not already a modal
      if (domain != host && isExternal(url)
      && !className.includes('modal-toggle')
      && !url.includes("tel:")) {
        link.className = className + ' modal-toggle';
        link.setAttribute('data-link', url);
        link.setAttribute('data-target', 'news-modal');


      }
    }
  }

  // Find all external links in content and apply modal insterstitials
  for (var l = 0, links = document.querySelectorAll('a'), ll = links.length; l < ll; ++l ){
    makeExternal(links[l]);
  }

  getAllExternalModal();

  var mt = document.querySelectorAll(".login-modal-toggle");
  var i = 0;
  for (i = 0; i < mt.length; i++) {
     mt[i].addEventListener("click", function() {
        var targetId = this.getAttribute("data-target");
        var target = document.getElementById(targetId);
        if(targetId=="login-modal"){
          var closeItem = document.getElementById("close-login");
        }else{
          var closeItem = document.getElementById("close-enroll");
        }

        closeItem.focus();
        target.style.opacity = 1;
        target.style.display = "flex";
        target.style.zIndex = 9999;


     });
  }


  // hide show forgot and login box

    jQuery('.forgot-password-link').click(function() {
      jQuery('#forgot-password-box').show();
      jQuery('#login-box').hide();

      jQuery('#close-login').focus();
    });

    jQuery('.login-link').click(function() {
      jQuery('#forgot-password-box').hide();
      jQuery('#login-box').show();
      jQuery('#close-login').focus();
    });



  //trap tabs inside modal
  jQuery('#login-modal').keydown(function(event) {
    trapTabKey(jQuery(this), event);
  })

  jQuery('#enroll-modal').keydown(function(event) {
    trapTabKey(jQuery(this), event);
  })

  jQuery('#news-modal').keydown(function(event) {
    trapTabKey(jQuery(this), event);
  })

    // jQuery formatted selector to search for focusable items
  var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";


  function trapTabKey(obj, evt) {

      // if tab or shift-tab pressed
      if (evt.which == 9) {

          // get list of all children elements in given object
          var o = obj.find('*');

          // get list of focusable items
          var focusableItems;
          focusableItems = o.filter(focusableElementsString).filter(':visible')

          // get currently focused item
          var focusedItem;
          focusedItem = jQuery(':focus');

          // get the number of focusable items
          var numberOfFocusableItems;
          numberOfFocusableItems = focusableItems.length

          // get the index of the currently focused item
          var focusedItemIndex;
          focusedItemIndex = focusableItems.index(focusedItem);

          if (evt.shiftKey) {
              //back tab
              // if focused on first item and user preses back-tab, go to the last focusable item
              if (focusedItemIndex == 0) {
                  focusableItems.get(numberOfFocusableItems - 1).focus();
                  evt.preventDefault();
              }

          } else {
              //forward tab
              // if focused on the last item and user preses tab, go to the first focusable item
              if (focusedItemIndex == numberOfFocusableItems - 1) {
                  focusableItems.get(0).focus();
                  evt.preventDefault();
              }
          }
      }

  }
}



